var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("components.advance.panelTitle")))]),
      _c("delegation-menu"),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.delegationAdvances,
          search: _vm.search,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false
        },
        scopedSlots: _vm._u([
          {
            key: "header.delegation_number",
            fn: function(ref) {
              var header = ref.header
              return [
                _c("icon-data-table-header", { attrs: { header: header } })
              ]
            }
          },
          {
            key: "header.delegation_order_number",
            fn: function(ref) {
              var header = ref.header
              return [
                _c("icon-data-table-header", { attrs: { header: header } })
              ]
            }
          },
          {
            key: "header.status",
            fn: function(ref) {
              var header = ref.header
              return [
                _c("icon-data-table-header", { attrs: { header: header } })
              ]
            }
          },
          {
            key: "header.payment_type",
            fn: function(ref) {
              var header = ref.header
              return [
                _c("icon-data-table-header", { attrs: { header: header } })
              ]
            }
          },
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", [
                    _vm._v(" " + _vm._s(props.item.user_full_name) + " ")
                  ]),
                  _c("td", [
                    _vm._v(
                      " " +
                        _vm._s(props.item.amount_in_currency) +
                        " " +
                        _vm._s(props.item.currency) +
                        " "
                    ),
                    props.item.currency !== "PLN"
                      ? _c("span", [
                          _vm._v("(" + _vm._s(props.item.amount) + " PLN)")
                        ])
                      : _vm._e()
                  ]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "span",
                                      _vm._g({}, on),
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { size: "24" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                props.item.delegation_id !==
                                                  null
                                                  ? "assignment"
                                                  : "fa-minus"
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  props.item.delegation_number === null
                                    ? _vm.$t("global.notSet")
                                    : props.item.delegation_number
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "span",
                                      _vm._g({}, on),
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { size: "24" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                props.item
                                                  .delegation_order_id !== null
                                                  ? "send"
                                                  : "fa-minus"
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  props.item.delegation_order_number === null
                                    ? _vm.$t("global.notSet")
                                    : props.item.delegation_order_number
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "span",
                                      _vm._g({}, on),
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { size: "24" } },
                                          [
                                            props.item.status === 1
                                              ? [_vm._v("fa-check-circle")]
                                              : props.item.status === -1
                                              ? [_vm._v("fa-times-circle")]
                                              : props.item.status === 2
                                              ? [_vm._v("fa-wallet")]
                                              : [_vm._v("fa-question-circle")]
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _c(
                            "span",
                            [
                              props.item.status === 1
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "delegation.advance.status.approved"
                                        )
                                      )
                                    )
                                  ]
                                : props.item.status === -1
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "delegation.advance.status.rejected"
                                        )
                                      )
                                    )
                                  ]
                                : props.item.status === 2
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("delegation.advance.status.paid")
                                      )
                                    )
                                  ]
                                : [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "delegation.advance.status.unknown"
                                        )
                                      )
                                    )
                                  ]
                            ],
                            2
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "span",
                                      _vm._g({}, on),
                                      [
                                        _c("v-icon", [
                                          _vm._v(
                                            _vm._s(
                                              props.item.payment_type === 1
                                                ? "fa-money-bill"
                                                : "fa-university"
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  props.item.payment_type === 1
                                    ? _vm.$t("delegation.advance.paymentCash")
                                    : _vm.$t(
                                        "delegation.advance.paymentTransfer"
                                      )
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c("td", [_vm._v(_vm._s(props.item.payment_date))]),
                  _c(
                    "td",
                    { staticClass: "text-no-wrap text-center" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "span",
                                      _vm._g({}, on),
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.print(props.item.id)
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-file-download")
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("delegation.advance.download")) +
                                " "
                            )
                          ])
                        ]
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "span",
                                      _vm._g({}, on),
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.downloadAttachments(
                                                  props.item.id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("fa-download")
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "delegation.advance.downloadAttachments"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ]
                      ),
                      props.item.can_accept
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "span",
                                          _vm._g({}, on),
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.accept(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("check_circle")
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("delegation.advance.accept")
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      props.item.can_accept
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "span",
                                          _vm._g({}, on),
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.reject(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("block")])],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("delegation.advance.reject")
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      props.item.can_payout
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "span",
                                          _vm._g({}, on),
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openPayoutDialog(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("fa-cash-register")
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("delegationAdvance.payoutTooltip")
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "300px" },
          model: {
            value: _vm.payoutDialog,
            callback: function($$v) {
              _vm.payoutDialog = $$v
            },
            expression: "payoutDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    { ref: "form" },
                    [
                      _c("h3", [_vm._v("Wypłać zaliczkę")]),
                      _c("date-picker", {
                        attrs: {
                          model: _vm.payoutAdvanceDate,
                          label: "Data wypłacenia",
                          rules: [
                            function(v) {
                              return !!v || _vm.$t("global.required")
                            }
                          ]
                        },
                        on: {
                          "update:model": function($event) {
                            _vm.payoutAdvanceDate = $event
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: {
                        click: function($event) {
                          _vm.payoutDialog = false
                        }
                      }
                    },
                    [_vm._v("Anuluj")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "blue darken-1",
                        text: "",
                        disabled: _vm.$store.getters["Ajax/loading"]
                      },
                      on: {
                        click: function($event) {
                          return _vm.payout()
                        }
                      }
                    },
                    [_vm._v("Wypłać")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }